module.exports = __webpack_public_path__ + "img/student_report_02.8fd59aa3.png";